export default [
  {
    path: '/',
    name: 'index',
    component: () => import('../pages/layout'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login'),
    meta: {
      isAuth: false,
      title: "登录"
    }
  },
  {
    path: '/bigScreen',
    name: 'bigScreen',
    component: () => import('@/views/BigScreen'),
    meta: {
      isAuth: false,
      title: "平台运行实况"
    }
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/Test'),
    meta: {
      isAuth: false,
      title: "测试"
    }
  },
  {
    path: '/workstation',
    name: 'workstation',
    component: () => import('@/views/jc/Workstation'),
    meta: {
      isAuth: false,
      title: "医生工作站",
    }
  },
]